import { AGENT_IMPORT_MAX_AGENTS_PER_REQUEST } from "../constants/agent-import";
import type { IAgentImportResult, IImportAgentsPayload } from "../types";
import type { ApiClient } from "./client";
import { importInBatches } from "./import-in-batches";

// NOTE: NSAI-6677 — imports agents the client already holds (parsed from a
// file exported from another platform) as private NSAI Assistants.
export class AgentImportApi {
  constructor(private readonly apiClient: ApiClient) {}

  async importAgents({
    agents,
  }: IImportAgentsPayload): Promise<IAgentImportResult[]> {
    return importInBatches({
      agents,
      batchSize: AGENT_IMPORT_MAX_AGENTS_PER_REQUEST,
      sendBatch: async (batch) => {
        const response = await this.apiClient.post<IAgentImportResult[]>(
          "/integrations/agent-import",
          { agents: batch },
        );
        return response.data;
      },
    });
  }
}
